import { cn } from 'src/utils'

import { CALL_VOLUME_BINS, ZERO_BIN_CLASS } from './heatmapBins'

const Swatch = ({ className }: { className: string }) => (
  <span className={cn('inline-block h-2.5 w-3.5 rounded-sm', className)} />
)

/**
 * Legend for the call-volume intensity ramp. Wraps onto multiple lines so the
 * 7-bin ramp doesn't overflow the card on narrow widths.
 */
export const HeatmapLegend = () => (
  <div
    className="flex flex-wrap items-center gap-x-2.5 gap-y-1 text-[11px] text-doubleNickel-gray-500"
    data-testid="heatmap-legend"
  >
    <span className="flex items-center gap-1">
      <Swatch className={ZERO_BIN_CLASS} />0
    </span>
    {CALL_VOLUME_BINS.map((bin) => (
      <span key={bin.label} className="flex items-center gap-1">
        <Swatch className={bin.className} />
        {bin.label}
      </span>
    ))}
  </div>
)

export default HeatmapLegend
